import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {StatistiquesEGAlimService} from "../../../core/services/egalim/statistiques-egalim.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";
import {UtilsService} from "../../../core/utils/utils.service";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {DateLevelEnum} from "../../../shared/date/picker/date-level-enum";
import {GraphQLService} from "../../../core/services/technique/graphql.service";
import {PointTeledeclarationEgalimDto} from "../../../core/dtos/egalim/point-teledeclaration-egalim-dto";
import {ToastService} from "../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";

@Component({
  selector: 'yo-statistiques-egalim-creation-dialog',
  templateUrl: './statistiques-egalim-creation-dialog.component.html',
  styleUrls: ['./statistiques-egalim-creation-dialog.component.scss']
})
export class StatistiquesEgalimCreationDialogComponent implements OnInit, OnDestroy {

  public displayed: boolean = false;

  public pointsTeledeclaration: PointTeledeclarationEgalimDto[] = [];

  public idSiteSelected: number;
  public dateSelected: Date = new Date();
  public idsPointTeledeclatrationSelected: number[] = [];

  private subOpen: Subscription;
  private subPointTeledeclaration: Subscription;

  public readonly DateLevelEnum = DateLevelEnum;

  constructor(
    private utilsSvc: UtilsService,
    private auth2Svc: Auth2Service,
    private graphQlSvc: GraphQLService,
    private statistiquesEgalimSvc: StatistiquesEGAlimService,
    private toastSvc: ToastService) {
  }

  ngOnInit(): void {
    this.initSubOpen();
    this.initIdsPointTeledeclaration();
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.subOpen);
    this.utilsSvc.unsubscribe(this.subPointTeledeclaration);
  }

  initSubOpen = () => {
    this.subOpen = this.statistiquesEgalimSvc.openCreationDialog$.subscribe((isOpen) => {
      this.idSiteSelected = null;
      this.dateSelected = new Date();
      this.idsPointTeledeclatrationSelected = [];
      this.displayed = isOpen;
    })
  }

  initIdsPointTeledeclaration = () => {
    this.subPointTeledeclaration = this.graphQlSvc.sendQuery(`
      {
        allPointTeledeclarationEGAlim {
          id,
          libelle
        }
      }
    `).subscribe((result) => {
      this.pointsTeledeclaration = result.allPointTeledeclarationEGAlim;
    });
  }

  public getSaveButtonTheme = () => {
    return ButtonThemeEnum.SAVE;
  };

  public save = () => {
    this.statistiquesEgalimSvc.generate(this.idSiteSelected, this.dateSelected.getFullYear(), this.idsPointTeledeclatrationSelected).subscribe(result => {
      if (result)
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, "Statistiques EGAlim générées avec succès");
        result.resultList.forEach(statistique => {
          this.statistiquesEgalimSvc.onStatistiqueEGAlimGenerated(statistique);
        })
      this.displayed = false;
    })
  };

  findAllLocalSites = () => this.auth2Svc.utilisateur.siteListLocaux;

  onChangeSite = (id: number) => {
    this.idSiteSelected = id;
  };

  onChangeDate = (date: Date) => {
    this.dateSelected = date;
  };

  onChangePointLivraison = (ids: number[]) => {
    this.idsPointTeledeclatrationSelected = ids;
  };

  isGenerationPossible = (): boolean => {
    return this.dateSelected && this.idSiteSelected && this.idsPointTeledeclatrationSelected.length > 0;
  }
}
